// extracted by mini-css-extract-plugin
module.exports = {"faqRegion":"FAQBlock_faqRegion__2mvGE","faqRegionTitle":"FAQBlock_faqRegionTitle__-3njJ"};